import CodeMirror from "@uiw/react-codemirror";
import React from "react";
import { oneDark } from "@codemirror/theme-one-dark";
import { sql } from "@codemirror/lang-sql";
import styled from "styled-components";

interface CodeMirrorEditorProps {
  value: string;
  onChange: (value: string) => void;
}

export const codeBgColor = "#011627";
export const codeTextColor = "#ffffff";

const EditorWrapper = styled.div`
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  overflow: hidden;
  height: 100%;
  width: 100%;
  & .cm-theme,
  & .cm-editor {
    height: 100%;
    .cm-content {
      padding: 0.625rem;
      background-color: ${codeBgColor};
      color: ${codeTextColor};
    }
    .ͼq,
    .ͼv {
      color: ${codeTextColor};
    }
    .ͼp {
      color: #4b94cd;
    }
    .ͼu {
      color: #c64174;
    }
  }
  & .cm-scroller {
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) =>
      `${theme.palette.border.main} ${theme.palette.background.paper}`};

    &::-webkit-scrollbar {
      width: 12px;
      height: 12px;
    }

    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.palette.background.paper};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.palette.border.main};
      border-radius: 10px;
      border: 3px solid ${({ theme }) => theme.palette.background.paper};
    }
  }

  & .cm-layer.cm-selectionLayer {
    z-index: 1 !important;
    opacity: 0.5;
  }
`;

const CodeMirrorEditor: React.FC<CodeMirrorEditorProps> = ({
  value,
  onChange,
}) => {
  return (
    <EditorWrapper>
      <CodeMirror
        value={value}
        height="100%"
        theme={oneDark}
        extensions={[sql({})]}
        onChange={onChange}
        basicSetup={{
          lineNumbers: false,
          highlightActiveLine: true,
          highlightSpecialChars: true,
          foldGutter: false,
          dropCursor: true,
          allowMultipleSelections: true,
          indentOnInput: true,
          syntaxHighlighting: true,
          bracketMatching: true,
          closeBrackets: true,
          autocompletion: true,
          rectangularSelection: true,
          crosshairCursor: true,
          highlightSelectionMatches: true,
          tabSize: 2,
        }}
      />
    </EditorWrapper>
  );
};

export default CodeMirrorEditor;
